import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { adminCodeGeneratorSettingsActions } from './slice';
import capabilities from './capabilities';

export const ApiCodeGeneratorSettingsGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .post('admin/codegeneratorsettings/list', { filters, orderBy, groupBy, page, limit }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.setList(response?.data?.list));
                    dispatch(adminCodeGeneratorSettingsActions.setCount(response?.data?.count));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsCountCollection = async ({
    filters = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('admin/codegeneratorsettings/count', { filters }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiCodeGeneratorSettingsPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .post('admin/codegeneratorsettings', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .post('admin/codegeneratorsettings/delete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(adminCodeGeneratorSettingsActions.startExporting());
    }

    await gestopAPI
        .post(
            'admin/codegeneratorsettings/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .put(`admin/codegeneratorsettings/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .patch(`admin/codegeneratorsettings/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .delete(`admin/codegeneratorsettings/${id}`, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(adminCodeGeneratorSettingsActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiCodeGeneratorSettingsGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(adminCodeGeneratorSettingsActions.startLoading());
    }

    await gestopAPI
        .get(`admin/codegeneratorsettings/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(adminCodeGeneratorSettingsActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(adminCodeGeneratorSettingsActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
